module.exports = __webpack_public_path__ + "static/media/taxas_envio.cc52ffb1.jpg";